import api from '../config/api';

const productTypeService = {
  async getAll() {
    const response = await api.get('/api/product-types');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/product-types/${id}`);
    return response.data;
  },

  async create(productTypeData) {
    const response = await api.post('/api/product-types', productTypeData);
    return response.data;
  },

  async update(id, productTypeData) {
    const response = await api.put(`/api/product-types/${id}`, productTypeData);
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/api/product-types/${id}`);
    return response.data;
  },
};

export default productTypeService;
